// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"AuthorDropdown_ItemsWrapper__3C7A1","Item":"AuthorDropdown_Item__WQSuV","Active":"AuthorDropdown_Active__vKnBQ"};